let sessionBucket: number;
export default function getSessionSampleBucket(): number {
    // bucketize into [0, 9999]
    if (sessionBucket === undefined) {
        sessionBucket = Math.floor(Math.random() * 10000);
    }
    
    return sessionBucket;
}

export function isCurrentSessionInSample(sampleRate: number): boolean {
    return getSessionSampleBucket() < sampleRate * 100;
}
